import React from 'react';
import { Label, TextField, Text, Stack, Icon } from '@fluentui/react';
import ComboBoxSearch from '../../Common/ComboBoxSearch';
import { IComboBoxOption, Image } from '@fluentui/react';
import { Club } from '../../../system/Club/Club';
import { DocumentoTipo } from '../../../system/DocumentoTipo/DocumentoTipo';
import { Jugador } from '../../../system/Jugador/Jugador';
import SingleFileDropzone from '../../Common/FileDropzone/SingleFileDropzone';
import DialogTemplate from '../../Common/DialogTemplate';
import { AppContext } from '../../../AppInRouterContext';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import { checkMaxSize } from '../WizardAptoFisico';
import { formatMiles } from './DatosIniciales';

interface ISubirComprobanteMedico {
  appContext: AppContext;

  jugador: Jugador;
  nombre: string;
  apellido: string;
  setNombre: (value: string) => void;
  setApellido: (value: string) => void;
  fileComprobanteMedico: File | null;
  onDropComprobanteMedico: (file: File) => void;
  back: () => void;
  tipoDocumento: string;
  numeroDocumento: string;
  isDni: boolean;
}

export const SubirComprobanteMedico = (props: ISubirComprobanteMedico) => {
  const [disableInputs, setDisableInputs] = React.useState(true);
  const [showNotMe, setShowNotMe] = React.useState<boolean>(false);
  const [showSoyYo, setShowSoyYo] = React.useState<boolean>(false);
  const [showNoSoyYo, setShowNoSoyYo] = React.useState<boolean>(false);

  // const url = React.useMemo(() => {
  //   if (props.fileComprobanteMedico) {
  //     const url = URL.createObjectURL(props.fileComprobanteMedico!);
  //     return url;
  //   }
  //   return '';
  // }, [props.fileComprobanteMedico]);

  return (
    <div>
      <div className="text-center">
        <Text variant="xLarge">¡Hola {props.jugador.fullname()}!</Text>
      </div>
      {/* <div>
        <Label>Nombre</Label>
        <TextField
          disabled={disableInputs}
          value={props.nombre}
          onChange={(e, nv) => props.setNombre(nv ? nv : '')}
        />
      </div>

      <div>
        <Label>Apellido</Label>
        <TextField
          disabled={disableInputs}
          value={props.apellido}
          onChange={(e, nv) => props.setApellido(nv ? nv : '')}
        />
      </div> */}

      <div className="text-center">
        <Text variant="small" className="mt-1 link-styles" onClick={() => setShowNotMe(true)}>
          No soy yo
        </Text>
      </div>

      <div className="text-center mt-5">
        <div className="text-center mt-5">
          <SingleFileDropzone
            label="Subir comprobante médico"
            onDrop={(file) => {
              props.onDropComprobanteMedico(file);
            }}
          ></SingleFileDropzone>
        </div>
      </div>

      <div className="text-center">
        <Text variant="xSmall" className="" title="Formatos admitidos">
          (JPG, JPEG, GIF, PNG, PDF, DOCX, ODT, RTF)
        </Text>
      </div>
      <div className="mt-5">
        <Text variant="small" className="error-color">
          <Icon
            iconName="AlertSolid"
            className="error-color"
            style={{ position: 'relative', top: 2, marginRight: 3 }}
          ></Icon>
          El contenido subido queda bajo exclusiva responsabilidad del presentante
        </Text>
      </div>

      {/* {props.fileComprobanteMedico &&
        checkMaxSize(props.fileComprobanteMedico.size) &&
        isImage(props.fileComprobanteMedico.type) && (
          <Stack horizontalAlign="center" className="text-center mt-1">
            <Image src={url} alt={props.fileComprobanteMedico.name} height={80} />
          </Stack>
        )} */}

      {props.fileComprobanteMedico && (
        <div className="mt-2 text-center">
          <Text block variant="medium" className="">
            <Icon iconName="SkypeCircleCheck" style={{ color: '#107C10', marginRight: 10 }}></Icon>
            Archivo {obtenerExtension(props.fileComprobanteMedico.name)} cargado -{' '}
            {formatFileSize(props.fileComprobanteMedico.size)}
          </Text>
          {!checkMaxSize(props.fileComprobanteMedico.size) && (
            <Text block variant="medium" className="error-color">
              El tamaño del comprobante es demasiado grande, el maximo es de 2MB
            </Text>
          )}
        </div>
      )}

      <DialogTemplate
        showDialog={showNotMe}
        toggleShowDialog={() => {
          setShowNotMe(!showNotMe);
        }}
        title={`Este es tu ${props.tipoDocumento}?`}
        onAccept={() => {
          setShowSoyYo(true);
          setDisableInputs(false);
        }}
        onCancel={() => {
          setShowNoSoyYo(true);
        }}
        acceptText={'Si'}
        cancelText={'No'}
        maxWidth={200}
      >
        <div>
          <Text className="fw-500" block variant="mediumPlus">
            {props.isDni ? formatMiles(props.numeroDocumento) : props.numeroDocumento}
          </Text>
        </div>
      </DialogTemplate>

      <DialogTemplate
        showDialog={showSoyYo}
        toggleShowDialog={() => {
          setShowSoyYo(!showSoyYo);
        }}
        title={`Comunicate con tu delegado`}
        onAccept={() => {
          setShowSoyYo(!showSoyYo);
        }}
        onCancel={() => {}}
        acceptText={'Entendido'}
        cancelText={''}
        hideCancelButton
        maxWidth={200}
      >
        <div>
          <Text className=" mt-2" block variant="mediumPlus">
            <Icon
              iconName="AlertSolid"
              className="error-color"
              style={{ position: 'relative', top: 2, marginRight: 3 }}
            ></Icon>
            Si es tu {props.tipoDocumento}, comunicate con el delegado de tu club para actualizar tus datos
          </Text>
        </div>
      </DialogTemplate>

      <DialogTemplate
        showDialog={showNoSoyYo}
        toggleShowDialog={() => {
          setShowNoSoyYo(!showNoSoyYo);
        }}
        title={`Volver a empezar`}
        onAccept={() => {
          setShowNoSoyYo(!showNoSoyYo);
          props.back();
        }}
        onCancel={() => {}}
        acceptText={'Entendido'}
        cancelText={''}
        hideCancelButton
        maxWidth={200}
      >
        <div>
          <Text className="mt-2" block variant="mediumPlus">
            Ingresa tus datos nuevamente
          </Text>
        </div>
      </DialogTemplate>
    </div>
  );
};

export const formatFileSize = (size: number): string => {
  if (size < 0) {
    throw new Error('El tamaño no puede ser negativo.');
  }

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = 0;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  return `${size.toFixed(2)} ${units[index]}`;
};

export const obtenerExtension = (archivo: string): string | null => {
  const partes = archivo.split('.');
  return partes.length > 1 ? partes.pop() || null : null;
};

export const isImage = (fileType: string): boolean => {
  return fileType.startsWith('image/');
};
